"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appHomeSchema = exports.appUiExtensionSchema = exports.appNavigationItemSchema = exports.appResourceTypeSchema = exports.appUiTargetSchema = exports.appUiRendererSchema = exports.appExtensionTypeSchema = exports.appSupportedPlatformSchema = exports.appCommercialModelSchema = exports.appUiRuntimeSchema = exports.appDeliveryModelSchema = exports.appPublisherKindSchema = exports.APP_RESOURCE_TYPES = exports.APP_UI_TARGETS = exports.APP_UI_RENDERERS = exports.APP_EXTENSION_TYPES = exports.APP_SUPPORTED_PLATFORMS = exports.APP_COMMERCIAL_MODELS = exports.APP_UI_RUNTIMES = exports.APP_DELIVERY_MODELS = exports.APP_PUBLISHER_KINDS = void 0;
const zod_1 = require("zod");
const permissions_1 = require("./permissions");
exports.APP_PUBLISHER_KINDS = ["CREWFSM", "PARTNER"];
exports.APP_DELIVERY_MODELS = [
    "CORE_ADDON",
    "EMBEDDED_APP",
    "WEBHOOK_INTEGRATION",
    "OAUTH_INTEGRATION",
];
exports.APP_UI_RUNTIMES = ["NONE", "NATIVE", "IFRAME"];
exports.APP_COMMERCIAL_MODELS = [
    "INCLUDED",
    "PLAN_GATED",
    "PAID_ADDON",
    "EXTERNAL_BILLING",
];
exports.APP_SUPPORTED_PLATFORMS = [
    "WEB",
    "MOBILE",
    "CUSTOMER_PORTAL",
];
exports.APP_EXTENSION_TYPES = [
    "APP_HOME",
    "NAV_ITEM",
    "BLOCK",
    "ACTION",
    "TAB",
    "DASHBOARD_WIDGET",
    "SETTINGS_PAGE",
];
exports.APP_UI_RENDERERS = ["NATIVE", "IFRAME"];
exports.APP_UI_TARGETS = [
    "admin.app.home",
    "admin.app.navigation",
    "admin.inbox.navigation",
    "admin.dashboard.block",
    "admin.job.details.block",
    "admin.job.details.context.block",
    "admin.job.details.action",
    "admin.customer.details.block",
    "admin.customer.details.action",
    "admin.estimate.details.block",
    "admin.estimate.details.action",
    "admin.invoice.details.block",
    "admin.invoice.details.action",
    "admin.settings.page",
    "admin.settings.navigation",
];
exports.APP_RESOURCE_TYPES = [
    "DASHBOARD",
    "LEAD",
    "JOB",
    "CUSTOMER",
    "ESTIMATE",
    "INVOICE",
    "SETTINGS",
];
exports.appPublisherKindSchema = zod_1.z.enum(exports.APP_PUBLISHER_KINDS);
exports.appDeliveryModelSchema = zod_1.z.enum(exports.APP_DELIVERY_MODELS);
exports.appUiRuntimeSchema = zod_1.z.enum(exports.APP_UI_RUNTIMES);
exports.appCommercialModelSchema = zod_1.z.enum(exports.APP_COMMERCIAL_MODELS);
exports.appSupportedPlatformSchema = zod_1.z.enum(exports.APP_SUPPORTED_PLATFORMS);
exports.appExtensionTypeSchema = zod_1.z.enum(exports.APP_EXTENSION_TYPES);
exports.appUiRendererSchema = zod_1.z.enum(exports.APP_UI_RENDERERS);
exports.appUiTargetSchema = zod_1.z.enum(exports.APP_UI_TARGETS);
exports.appResourceTypeSchema = zod_1.z.enum(exports.APP_RESOURCE_TYPES);
const identifierSchema = zod_1.z
    .string()
    .min(2)
    .max(80)
    .regex(/^[a-z0-9]+(?:[.-][a-z0-9]+)*$/);
const componentKeySchema = zod_1.z
    .string()
    .min(3)
    .max(120)
    .regex(/^[a-z0-9]+(?:[.-][a-z0-9]+)*$/);
const appRelativePathSchema = zod_1.z
    .string()
    .min(1)
    .max(240)
    .refine(isSafeAppRelativePath, "A safe app-relative path is required.");
const appRuntimeUrlSchema = zod_1.z
    .string()
    .url()
    .refine((value) => {
    const url = new URL(value);
    return (url.protocol === "https:" ||
        (url.protocol === "http:" && isDevelopmentHostname(url.hostname)));
}, "An HTTPS URL or local development URL is required.");
exports.appNavigationItemSchema = zod_1.z.object({
    id: identifierSchema,
    label: zod_1.z.string().trim().min(1).max(32),
    path: appRelativePathSchema,
    iconKey: identifierSchema.optional(),
    order: zod_1.z.number().int().min(0).max(100),
    requiredPermissions: zod_1.z.array(permissions_1.appPermissionSchema).default([]),
    platform: exports.appSupportedPlatformSchema.default("WEB"),
});
const extensionBaseSchema = zod_1.z.object({
    id: identifierSchema,
    target: exports.appUiTargetSchema,
    type: exports.appExtensionTypeSchema,
    platform: exports.appSupportedPlatformSchema.default("WEB"),
    title: zod_1.z.string().trim().min(1).max(80),
    description: zod_1.z.string().trim().min(1).max(240).optional(),
    requiredPermissions: zod_1.z.array(permissions_1.appPermissionSchema).default([]),
    resourceType: exports.appResourceTypeSchema.optional(),
    minHeight: zod_1.z.number().int().min(48).max(1_200).optional(),
    maxHeight: zod_1.z.number().int().min(48).max(1_200).optional(),
    route: appRelativePathSchema.optional(),
    version: zod_1.z.string().regex(/^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?$/),
    enabledByDefault: zod_1.z.boolean().default(true),
});
const nativeExtensionSchema = extensionBaseSchema.extend({
    renderer: zod_1.z.literal("NATIVE"),
    componentKey: componentKeySchema,
    entryUrl: zod_1.z.never().optional(),
});
const iframeExtensionSchema = extensionBaseSchema.extend({
    renderer: zod_1.z.literal("IFRAME"),
    entryUrl: appRuntimeUrlSchema,
    componentKey: zod_1.z.never().optional(),
});
exports.appUiExtensionSchema = zod_1.z
    .discriminatedUnion("renderer", [
    nativeExtensionSchema,
    iframeExtensionSchema,
])
    .superRefine((extension, context) => {
    if (extension.minHeight !== undefined &&
        extension.maxHeight !== undefined &&
        extension.minHeight > extension.maxHeight) {
        context.addIssue({
            code: "custom",
            message: "Extension minHeight cannot exceed maxHeight.",
            path: ["minHeight"],
        });
    }
    if (!targetSupportsExtensionType(extension.target, extension.type)) {
        context.addIssue({
            code: "custom",
            message: `Extension type ${extension.type} is not valid for ${extension.target}.`,
            path: ["type"],
        });
    }
    if ((extension.type === "NAV_ITEM" || extension.type === "SETTINGS_PAGE") &&
        !extension.route) {
        context.addIssue({
            code: "custom",
            message: `${extension.type} extensions require an app-relative route.`,
            path: ["route"],
        });
    }
});
exports.appHomeSchema = zod_1.z.discriminatedUnion("renderer", [
    zod_1.z.object({
        renderer: zod_1.z.literal("NATIVE"),
        homePath: appRelativePathSchema,
        componentKey: componentKeySchema,
        entryUrl: zod_1.z.never().optional(),
    }),
    zod_1.z.object({
        renderer: zod_1.z.literal("IFRAME"),
        homePath: appRelativePathSchema,
        routes: zod_1.z.array(appRelativePathSchema).max(16).optional(),
        entryUrl: appRuntimeUrlSchema,
        componentKey: zod_1.z.never().optional(),
    }),
]);
function isSafeAppRelativePath(value) {
    if (!value.startsWith("/") || value.startsWith("//"))
        return false;
    if (value.includes("?") || value.includes("#") || value.includes("\\")) {
        return false;
    }
    return value
        .split("/")
        .slice(1)
        .every((segment) => segment !== "." &&
        segment !== ".." &&
        (segment === "" || /^[A-Za-z0-9][A-Za-z0-9._-]*$/.test(segment)));
}
function isDevelopmentHostname(hostname) {
    const normalized = hostname.toLowerCase();
    return (normalized === "localhost" ||
        normalized.endsWith(".localhost") ||
        normalized.endsWith(".local") ||
        normalized.endsWith(".internal") ||
        normalized.endsWith(".test"));
}
function targetSupportsExtensionType(target, type) {
    if (target === "admin.app.home")
        return type === "APP_HOME";
    if (target === "admin.app.navigation" ||
        target === "admin.inbox.navigation" ||
        target === "admin.settings.navigation") {
        return type === "NAV_ITEM";
    }
    if (target === "admin.settings.page")
        return type === "SETTINGS_PAGE";
    if (target === "admin.dashboard.block") {
        return type === "BLOCK" || type === "DASHBOARD_WIDGET";
    }
    if (target.endsWith(".action"))
        return type === "ACTION";
    if (target.endsWith(".block"))
        return type === "BLOCK" || type === "TAB";
    return false;
}
//# sourceMappingURL=ui-extensions.js.map